import { render, staticRenderFns } from "./common-dialog.vue?vue&type=template&id=5e3923d1&scoped=true&"
import script from "./common-dialog.vue?vue&type=script&lang=js&"
export * from "./common-dialog.vue?vue&type=script&lang=js&"
import style0 from "./common-dialog.vue?vue&type=style&index=0&id=5e3923d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3923d1",
  null
  
)

export default component.exports